import PropTypes from 'prop-types';
import Router from 'next/router';
import getConfig from 'next/config';

import { FadeInAnimation, LinkUnderlineAnimation } from '../shared';

import FindASpaceCard from '../shared/find-a-space-card.component';

const { publicRuntimeConfig } = getConfig();

const StayOrStyleSection = (props) => {    

    return (
        <div id="stay_or_style_section" className='stay-style-section'>
            <FadeInAnimation>
                <div>
                    <h4>{props.title}</h4>
                    <div className='stay-style-section-paragraph-container'>
                        <p className='stay-style-section-paragraph'>
                            {props.paragraph}
                        </p>
                        <div className='stay-style-section-link-container'>
                            <LinkUnderlineAnimation
                                href="/live/live-your-best-life#options_header"
                                id="learn_more_space"
                            >
                                Learn More
                            </LinkUnderlineAnimation>
                        </div>
                    </div>
                </div>
            </FadeInAnimation>
            {renderCards()}
        </div>
    );
};

function renderCards() {
    const onDailyClick = () => {
        Router.push('/bookings?term=Daily').then(() => window.scrollTo(0, 0));
    };

    const onMonthlyClick = () => {
        Router.push('/bookings?term=Monthly').then(() => window.scrollTo(0, 0));
    };

    const onPrivateApartmentClick = () => {
        Router.push('/bookings?style=private_apartment').then(() => window.scrollTo(0, 0));
    };

    const onPrivateBedroomClick = () => {
        Router.push('/bookings?style=private_bedroom').then(() => window.scrollTo(0, 0));
    };

    const onSharedMaleClick = () => {
        Router.push('/bookings?style=shared_male').then(() => window.scrollTo(0, 0));
    };

    const onSharedFemaleClick = () => {
        Router.push('/bookings?style=shared_female').then(() => window.scrollTo(0, 0));
    };

    const renderTermCards = () => (
        <div className='main-grid-container main-grid-spacing-xs-3 stay-style-section-grid'>
            {publicRuntimeConfig.HOMII_FEATURE_DAILY_TERM_ENABLED && (
                <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                    <FindASpaceCard
                        imageSource="/assets/images/daily-rentals-icon.png"
                        imageAlt="clock"
                        title="Daily Rentals"
                        description="Flexible bookings"
                        onClick={onDailyClick}
                    />
                </div>
            )}

            <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                <FindASpaceCard
                    imageSource="/assets/images/monthly-rentals-icon.png"
                    imageAlt="calendar"
                    title="Monthly Rentals"
                    description="Something a bit more permanent"
                    onClick={onMonthlyClick}
                />
            </div>
        </div>
    );

    return (
        <>
            <FadeInAnimation>
                {publicRuntimeConfig.HOMII_FEATURE_DAILY_TERM_ENABLED && renderTermCards()}
                <div className='main-grid-container main-grid-spacing-xs-3 stay-style-section-grid'>
                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/private-space-icon.png"
                            imageAlt="house-with-person"
                            title="Private Apartment"
                            description="Have the apartment to yourself"
                            onClick={onPrivateApartmentClick}
                        />
                    </div>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/shared-space-icon.png"
                            imageAlt="house-with-people"
                            title="Private Bedroom"
                            description="Your own bedroom in a shared living space"
                            onClick={onPrivateBedroomClick}
                        />
                    </div>
                </div>

                <div className='main-grid-container main-grid-spacing-xs-3 stay-style-section-grid'>
                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/shared-room.png"
                            imageAlt="shared-room-with-curtains"
                            title="Shared Male"
                            description="Share a room with another male HOMii"
                            onClick={onSharedMaleClick}
                        />
                    </div>

                    <div className='main-grid-item main-grid-md-6 main-grid-sm-12 main-grid-xs-12'>
                        <FindASpaceCard
                            imageSource="/assets/images/shared-room.png"
                            imageAlt="shared-room-with-curtains"
                            title="Shared Female"
                            description="Share a room with another female HOMii"
                            onClick={onSharedFemaleClick}
                        />
                    </div>
                </div>
                {!publicRuntimeConfig.HOMII_FEATURE_DAILY_TERM_ENABLED && renderTermCards()}
            </FadeInAnimation>
        </>
    );
}

export default StayOrStyleSection;

StayOrStyleSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
};

